import React from "react";
import { makeStyles, Box, Grid, Link, Typography, Theme } from "@material-ui/core";
import { colorBorder } from "../../../Constants/theme";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
    link: {
        border: "none",
        paddingBottom: "12px",
        marginRight: "37px",
        [theme.breakpoints.down("sm")]: {
            marginRight: "15px",
        }
    },
    activeLink: {
        borderBottom: `2px solid ${colorBorder}`,
        [theme.breakpoints.down("sm")]: {
            marginRight: "15px",
        }
    },
    text: {
        [theme.breakpoints.down("xs")]: {
            fontSize: 14
        }
    }
}));

const AppointmentsInnerNavigation = () => {
    const classes = useStyles();
    return (
        <Box marginBottom="30px">
            <Grid container >
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink} exact to="/appointments">
                    <Typography color="textPrimary" className={classes.text}>Upcoming Appointments</Typography>
                </Link>
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink} exact to="/appointments/past">
                    <Typography color="textPrimary" className={classes.text}>Past Appointments</Typography>
                </Link>
            </Grid>
        </Box>
    );
};

export default AppointmentsInnerNavigation;
